<template>
  <div>
    <textarea ref="summernote"></textarea>
  </div>
</template>

<script>
import 'jquery'
import 'popper.js'
import 'bootstrap'
import 'summernote/dist/summernote-bs4.css'
import 'summernote/dist/summernote-bs4.js'

export default {
  name: 'o-summernote-editor',
  props: {
    value: String
  },
  data() {
    return {
      initialized: false
    }
  },
  watch: {
    value(newVal) {
      if (this.initialized && this.getCode() !== newVal) {
        this.setCode(newVal)
      }
    }
  },
  methods: {
    initEditor() {
      if (this.initialized) return
      $(this.$refs.summernote).summernote({
        minHeight: 200, // set minimum height of editor
        width: 333,
        toolbar: [
          ['style', ['clear']],
          ['para', ['paragraph']],
          ['insert', ['link']]
        ],
        callbacks: {
          onChange: (contents) => {
            this.$emit('input', contents)
          }
        }
      })
      this.setCode(this.value)
      this.initialized = true
    },
    setCode(content) {
      $(this.$refs.summernote).summernote('code', content)
    },
    getCode() {
      return $(this.$refs.summernote).summernote('code')
    },
    destroyEditor() {
      if (this.initialized) {
        $(this.$refs.summernote).summernote('destroy')
        this.initialized = false
      }
    }
  },
  beforeDestroy() {
    this.destroyEditor()
  }
}
</script>
